// AUTO-GENERATED by scripts/build-registry.js: study entry for meteorology/altimeter-error.
import { mount } from '#engine/lesson-page.js';
import g0 from '../lessons/meteorology/altimeter-error/altimeter-error.js';
import g1 from '../lessons/meteorology/altimeter-error/altimeter-setting-error.js';

mount([g0, g1]);
